<template>
    <div>
        <div class="flex justify-center">
            <vs-card class="w-10/12 mt-5 shadow-lg card relative">
                <form ref="form" @submit.prevent="validate" class="flex flex-col items-center">
                    <div class="w-10/12 mt-10">
                        <h2 class="mb-4">Welcome</h2>
                        <p class="text-lg">
                            Please download the Wellful app via the links below. Then sign in to
                            your account to unlock your subscription.
                        </p>
                    </div>

                    <app-links />

                    <img
                        src="@/assets/images/croc.png"
                        height="250"
                        alt="Croc Image"
                        class="croc"
                    />
                </form>
            </vs-card>
        </div>
    </div>
</template>

<script>
import { mapParams } from '@/plugins/mappers'
import { mapGetters } from 'vuex'
import AppLinks from './AppLinks.vue'
export default {
    name: 'welcome',
    components: { AppLinks },
    data() {
        return {
            activeItem: 0,
            subscribe: 0,
            email: null,
            password: null,
            passwordConfirm: null,
            firstName: null,
            fullName: null,
            // cardNumber: null,
            // expiryDate: null,
            // ccv: null,
            loading: false,
            country: 13
        }
    },
    computed: {
        ...mapGetters({
            currentUser: 'auth/current_user'
        })
    },
    methods: {
        async validate() {
            // this.$validator.validateAll().then(async (result) => {
            //     if (result) {
            //         try {
            //             var response = await this.$api.coupon.redeemCoupon(this.details)
            //             this.notifySuccess('Signed up successfully', 'You signed up successfully', 5000)
            //         } catch (err) {
            //             console.error(err)
            //             this.notifyError(`Error', 'Error message: ${err}`, 5000)
            //         } finally {
            //             this.loading = false
            //         }
            //     }
            // })
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
p {
    color: rgb(104, 104, 104);
}
.croc {
    position: absolute;
    left: -50px;
    bottom: 0;
}
#logo {
    background-color: #b7dcc9;
}
.card {
    border-radius: 30px;
    min-height: 400px;
    max-width: 650px;
}
.sign-up {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
}
.customPadding {
    padding: 8px;
}
.customPadding2 {
    padding: 10px;
}
@media only screen and (min-height: 1200px) {
    .card {
        height: 650px;
    }
}
@media only screen and (max-width: 650px) {
    .croc {
        display: none;
    }
}
</style>
